import React from "react";
import { Form } from "@redriver/cinnamon";
import { getServiceStatuses } from "./actions";

const ServiceStatusDropdown = ({ ...props }) => {
  return <Form.Dropdown {...props} lookupAction={getServiceStatuses} />;
};

export default ServiceStatusDropdown;
